<template>
  <div class="RestaurantPoll">
    <b-form-group v-if="showPoll" label="Pick A Few Restaurants That You Like:">
      <b-form-checkbox
        class="b-checkbox"
        v-for="option in pollData"
        v-model="selected"
        :key="option.id"
        :value="option"
        name="flavour-3a"
        button
        button-variant="light"
      >
        {{ option.name }}
        <br>
        <b-img class="b-image" v-bind:src="option.image_url" rounded></b-img>
      </b-form-checkbox>
    </b-form-group>
    <b-button v-if="showPoll" @click="submitPoll" variant="primary">Submit</b-button>
    <div v-if="showResults">
      <h1>Results:</h1>
      <b-progress
        class="result-bar"
        :key="option.id"
        v-for="option in pollData"
        :max="100"
        height="2rem"
        animated
      >
        <b-progress-bar :value="option.votes/totalVotes*100">{{ option.name }}</b-progress-bar>
      </b-progress>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import db from "@/components/Firebase.js";

export default {
  data() {
    return {
      selected: [],
      pollData: [],
      totalVotes: 0,
      showPoll: true,
      showResults: false,
      pollID: this.$route.params.id,
      dbRef: db.collection("polls").doc(this.$route.params.id)
    };
  },
  computed: {
    ...mapGetters(["getPollID", "filteredRestaurants"])
  },
  methods: {
    submitPoll() {
      let pollBatch = db.batch();
      this.totalVotes += this.selected.length;
      //console.log(this.totalVotes);

      for (let i = 0; i < this.selected.length; i++) {
        this.selected[i].votes += 1;
        pollBatch.update(this.dbRef, {
          [this.selected[i].id]: this.selected[i]
        });
      }

      pollBatch.update(this.dbRef, { totalVotes: this.totalVotes });

      pollBatch
        .commit()
        .then(res => {
          //console.log("Document successfully written!");
          //   console.log(this.pollData);
          //   console.log("SORTED: ");

          this.dbRef
            .get()
            .then(doc => {
              if (doc.exists) {
                this.pollData = Object.values(doc.data());
                this.totalVotes = this.pollData.pop();
                this.pollData.sort(function(a, b) {
                  return a.votes < b.votes ? 1 : -1;
                });
                this.showResults = true;
                this.showPoll = false;
                //console.log(this.totalVotes);

                //console.log(this.pollData);
              } else {
                // doc.data() will be undefined in this case
                alert("No such document!");
              }
            })
            .catch(function(error) {
              alert(error);

              //console.log("Error getting document:", error);
            });
          //this.showResults = true;
        })
        .catch(function(error) {
          alert(error);
          //console.error("Error writing document: ", error);
        });
    },
    updatePollData() {}
  },
  created() {
    this.dbRef
      .get()
      .then(doc => {
        if (doc.exists) {
          this.pollData = Object.values(doc.data());
          this.totalVotes = this.pollData.pop();

          //console.log(this.totalVotes);

          //console.log(this.pollData);
        } else {
          // doc.data() will be undefined in this case
          alert("No such document!");
        }
      })
      .catch(function(error) {
        alert(error);
        //console.log("Error getting document:", error);
      });
  }
};
</script>

<style>
.result-bar {
  margin: 5px;
}

.progress-bar {
  animation-name: animateBar;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.4s;
}
@keyframes animateBar {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
